module.exports = __webpack_public_path__ + "static/img/rpacj2.91aadbb9.png";